import React from 'react';
import bem from 'utils/bem.js';
import Photo from 'components/TeaserPhoto/index.js'
import Icon from 'components/Icon/index.js';

const { cnBlock } = bem('video-placeholder--specialist');
export const SpecialistPlaceholder = ({order, className}) => {
    return (
        <div className={cnBlock(className)}>
            <Photo src={order.data.specialist.photoResized} />
            <Icon name={'video-camera-slash-shadow'} />
        </div>
    )
}
